import { render, staticRenderFns } from "./Ubps.view.vue?vue&type=template&id=376b52a4"
import script from "./Ubps.view.vue?vue&type=script&lang=js"
export * from "./Ubps.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports